var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"mx-auto mt-5",attrs:{"width":"400"}},[_c('v-alert',{attrs:{"prominent":"","type":"warning"}},[_vm._v(" Denne restauranten er ikke registrert. Ta kontakt med betjeningen ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }